import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { Plus, X, BookOpen, Send } from "lucide-react";
import { createKnowledge, getKnwoledge } from "../../actions/knowledge.actions";

const categoriesConfig = [
  { value: "LocalBoutique", label: "LocalBoutique" },
  { value: "LocalShop", label: "LocalShop" },
  { value: "WebTool 3", label: "WebTool 3" },
  { value: "NDD", label: "NDD/MAILS" },
  { value: "localagenda", label: "LocalAgenda" },
  { value: "reservit", label: "Reservit" },
  { value: "toolbox", label: "Toolbox" },
  { value: "seo", label: "SEO/SEM" },
  { value: "localetmoi", label: "Local&Moi" },
];

// Texte HTML du CKEditor vide ou composé uniquement de balises/espaces
const isEmptyHtml = (html) =>
  !html ||
  (html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, "")
    .trim() === "" &&
    !/<(img|iframe|figure)/i.test(html));

const AddKnowledge = ({ socket, userData }) => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [texte, setTexte] = useState("");
  const [categories, setCategories] = useState("");
  const [publishOnFeed, setPublishOnFeed] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  const resetForm = () => {
    setTitle("");
    setTexte("");
    setCategories("");
    setPublishOnFeed(false);
  };

  const close = () => {
    if (!submitting) setOpen(false);
  };

  useEffect(() => {
    if (!open) return;
    const onEsc = (e) => {
      if (e.key === "Escape") close();
    };
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, submitting]);

  const handleAddKnowledge = async (e) => {
    e.preventDefault();

    if (!title.trim()) return toast.error("Merci de renseigner un titre");
    if (!categories) return toast.error("Merci de choisir une catégorie");
    if (isEmptyHtml(texte))
      return toast.error("Merci de renseigner une description");

    setSubmitting(true);
    try {
      await dispatch(
        createKnowledge(
          userData.id,
          texte,
          categories,
          title.trim(),
          publishOnFeed
        )
      );
      await dispatch(getKnwoledge());
      toast.success("Tutoriel publié !");
      socket?.emit("sendNotificationAll", { senderName: userData.name });
      resetForm();
      setOpen(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Impossible de publier le tutoriel, réessayez."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="action_add">
      <ToastContainer />
      <button className="add-knowlegde" onClick={() => setOpen(true)}>
        <Plus size={16} /> Ajouter
      </button>

      {open &&
        createPortal(
          <div
            className="palette-overlay tuto-add-overlay"
            onMouseDown={(e) => {
              if (e.target === e.currentTarget) close();
            }}
          >
            <form
              className="team-modal tuto-add-modal"
              role="dialog"
              aria-label="Nouveau tutoriel"
              onSubmit={handleAddKnowledge}
            >
              <div className="team-modal-head">
                <span className="team-modal-title">
                  <BookOpen size={18} /> Nouveau tutoriel
                </span>
                <button
                  type="button"
                  className="palette-close"
                  onClick={close}
                  aria-label="Fermer"
                >
                  <X size={16} />
                </button>
              </div>

              <div className="team-modal-body tuto-add-body">
                <label className="tuto-field">
                  <span className="tuto-field-label">Titre</span>
                  <input
                    type="text"
                    className="tuto-input"
                    placeholder="Le titre du tuto"
                    onChange={(e) => setTitle(e.target.value)}
                    value={title}
                    autoFocus
                  />
                </label>

                <label className="tuto-field">
                  <span className="tuto-field-label">Catégorie</span>
                  <select
                    className="tuto-input"
                    value={categories}
                    onChange={(e) => setCategories(e.target.value)}
                  >
                    <option value="" disabled>
                      Choisir une catégorie
                    </option>
                    {categoriesConfig.map((category) => (
                      <option value={category.value} key={category.value}>
                        {category.label}
                      </option>
                    ))}
                  </select>
                </label>

                <div className="tuto-field">
                  <span className="tuto-field-label">Description</span>
                  <div className="tuto-editor">
                    <CKEditor
                      editor={Editor}
                      data=""
                      config={{
                        placeholder:
                          "Rédigez le tuto ici (sélectionnez du texte pour le mettre en forme)",
                      }}
                      onChange={(event, editor) => setTexte(editor.getData())}
                    />
                  </div>
                </div>

                <label className="tuto-check">
                  <input
                    type="checkbox"
                    checked={publishOnFeed}
                    onChange={(e) => setPublishOnFeed(e.target.checked)}
                  />
                  <span>Publier aussi sur le fil d'actualité</span>
                </label>
              </div>

              <div className="team-modal-footer tuto-add-footer">
                <button
                  type="button"
                  className="tuto-btn-ghost"
                  onClick={close}
                  disabled={submitting}
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  className="team-orga-btn"
                  disabled={submitting}
                >
                  <Send size={16} />
                  {submitting ? "Publication..." : "Ajouter et publier"}
                </button>
              </div>
            </form>
          </div>,
          document.body
        )}
    </div>
  );
};

export default AddKnowledge;
